// extracted by mini-css-extract-plugin
export default {"trigger":"AudioPlayerTrigger_trigger__4Hwmd","trigger__reset":"AudioPlayerTrigger_trigger__reset__kECc5","caption":"AudioPlayerTrigger_caption__pBJKY"};